import {
  LayoutDashboard, Users, Kanban, Building2, Activity,
  Clock, Plug, UserCog, Settings, Zap, BarChart3, CalendarDays, Wrench, Trello, Hammer
} from 'lucide-react';

export const NAV_ITEMS = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard', requiredPermission: 'dashboard.view_own' },
  { path: '/leads', icon: Users, label: 'Leads', requiredPermission: 'leads.view_own' },
  { path: '/pipeline', icon: Kanban, label: 'Pipeline', requiredPermission: 'pipeline.view' },
  { path: '/properties', icon: Building2, label: 'Diensten', requiredPermission: 'properties.view' },
  { path: '/builders', icon: Wrench, label: 'Builder Hub', requiredPermission: 'settings.edit_general' },
  { path: '/tool-hub', icon: Hammer, label: 'Tool Hub', requiredPermission: 'settings.edit_general' },
  { path: '/content-planner', icon: Trello, label: 'Content Planner', requiredPermission: null },
  { path: '/activities', icon: Activity, label: 'Activiteiten', requiredPermission: 'activities.view_own' },
  { path: '/follow-ups', icon: Clock, label: 'Opvolgingen', requiredPermission: 'follow_ups.view_own' },
  { path: '/calendar', icon: CalendarDays, label: 'Agenda', requiredPermission: null },
  { path: '/reports', icon: BarChart3, label: 'Rapporten', requiredPermission: 'reports.view' },
  { path: '/integrations', icon: Plug, label: 'Integraties', requiredPermission: 'integrations.view' },
  { path: '/automations', icon: Zap, label: 'Automatisering', requiredPermission: 'automations.view' },
  { path: '/team', icon: UserCog, label: 'Team', requiredPermission: 'team.view' },
  { path: '/settings', icon: Settings, label: 'Instellingen', requiredPermission: 'settings.view' },
];

export const BOTTOM_TABS = {
  admin: [
    { path: '/', icon: LayoutDashboard, label: 'Home' },
    { path: '/leads', icon: Users, label: 'Leads' },
    { path: '/pipeline', icon: Kanban, label: 'Pipeline' },
    { path: '/properties', icon: Building2, label: 'Diensten' },
  ],
  manager: [
    { path: '/', icon: LayoutDashboard, label: 'Home' },
    { path: '/leads', icon: Users, label: 'Leads' },
    { path: '/pipeline', icon: Kanban, label: 'Pipeline' },
    { path: '/team', icon: UserCog, label: 'Team' },
  ],
  agent: [
    { path: '/', icon: LayoutDashboard, label: 'Home' },
    { path: '/leads', icon: Users, label: 'Leads' },
    { path: '/pipeline', icon: Kanban, label: 'Pipeline' },
    { path: '/follow-ups', icon: Clock, label: 'Opvolging' },
  ],
};

export function getNavItemsForRole(role, userPermissions = null, isAdmin = false) {
  if (role === 'admin' || isAdmin) return NAV_ITEMS;

  if (!userPermissions) {
    const fallbackRoles = {
      manager: ['leads.view_own', 'pipeline.view', 'properties.view', 'activities.view_own', 'follow_ups.view_own', 'reports.view', 'team.view'],
      agent: ['leads.view_own', 'pipeline.view', 'properties.view', 'activities.view_own', 'follow_ups.view_own', 'reports.view'],
    };
    const allowed = fallbackRoles[role] || [];
    return NAV_ITEMS.filter(item => !item.requiredPermission || allowed.includes(item.requiredPermission));
  }

  return NAV_ITEMS.filter(item => {
    if (!item.requiredPermission) return true;
    return !!userPermissions[item.requiredPermission];
  });
}

export function getBottomTabsForRole(role) {
  if (['admin', 'manager', 'agent'].includes(role)) {
    return BOTTOM_TABS[role] || BOTTOM_TABS.agent;
  }
  return BOTTOM_TABS.agent;
}

export function canAccessRoute(role, path, userPermissions = null, isAdmin = false) {
  if (role === 'admin' || isAdmin) return true;

  const basePath = '/' + path.split('/').filter(Boolean).slice(0, 1).join('/');
  const item = NAV_ITEMS.find(n => n.path === basePath || (basePath === '/' && n.path === '/'));
  if (!item) return true;
  if (!item.requiredPermission) return true;

  if (userPermissions) {
    return !!userPermissions[item.requiredPermission];
  }

  const fallbackRoles = {
    manager: ['leads.view_own', 'pipeline.view', 'properties.view', 'activities.view_own', 'follow_ups.view_own', 'reports.view', 'team.view'],
    agent: ['leads.view_own', 'pipeline.view', 'properties.view', 'activities.view_own', 'follow_ups.view_own', 'reports.view'],
  };
  const allowed = fallbackRoles[role] || fallbackRoles.agent;
  return !item.requiredPermission || allowed.includes(item.requiredPermission);
}
